'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactStripeElements = require('react-stripe-elements');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _semanticUiReact = require('semantic-ui-react');

var _company = require('redux/modules/company');

require('./CheckoutForm.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    making_payment: state.company.making_payment,
    payment_success: state.company.payment_success,
    base_url: state.company.base_url,
    selected_plan: state.company.selected_plan,
    payment_amount: state.company.payment_amount
  };
}, {
  makePayment: _company.makePayment,
  pushState: _reactRouterRedux.push,
  showPaymentModal: _company.showPaymentModal
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(CheckoutForm, _Component);

  function CheckoutForm(props) {
    (0, _classCallCheck3.default)(this, CheckoutForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CheckoutForm.__proto__ || (0, _getPrototypeOf2.default)(CheckoutForm)).call(this, props));

    _this.handleChange = function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;

      _this.setState((0, _defineProperty3.default)({}, name, value));
    };

    _this.submit = _this.submit.bind(_this);

    _this.state = {
      userName: '',
      button_active: true,
      payment_error: false
    };
    return _this;
  }

  (0, _createClass3.default)(CheckoutForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.making_payment && !nextProps.making_payment) {
        this.setState({ button_active: true });
      }
      if (!nextProps.making_payment && nextProps.payment_success) {
        this.props.pushState(this.props.base_url + '/dashboard');
        this.props.showPaymentModal(false);
      }

      if (this.props.making_payment && !nextProps.making_payment && !nextProps.payment_success) {
        this.setState({ payment_error: true });
      }
    }
  }, {
    key: 'submit',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ev) {
        var _ref3, token, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // User clicked submit
                this.setState({ button_active: false });
                _context.next = 3;
                return this.props.stripe.createToken({ name: this.state.userName });

              case 3:
                _ref3 = _context.sent;
                token = _ref3.token;
                data = {};

                if (token) {
                  data['stripeToken'] = token.id;
                  data['plan'] = this.props.selected_plan;
                  this.props.makePayment(data);
                } else {
                  this.setState({ button_active: true });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit(_x) {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./CheckoutForm.scss');
      var _state = this.state,
          userName = _state.userName,
          userEmail = _state.userEmail,
          payment_error = _state.payment_error;


      return _react2.default.createElement(
        'div',
        { className: 'checkout' },
        _react2.default.createElement(
          'h2',
          null,
          'Would you like to complete the purchase?'
        ),
        _react2.default.createElement(_semanticUiReact.Input, { className: 'checkoutInput', placeholder: 'Enter Name', name: 'userName', value: userName, onChange: this.handleChange }),
        _react2.default.createElement(_reactStripeElements.CardElement, null),
        _react2.default.createElement(
          _semanticUiReact.Button,
          { disabled: !this.state.button_active, loading: !this.state.button_active, onClick: this.submit },
          'Pay ',
          this.props.payment_amount
        ),
        payment_error && _react2.default.createElement(
          'p',
          null,
          'Payment Error: Please contact team@hiration.com to help us resolve this issue.'
        )
      );
    }
  }]);
  return CheckoutForm;
}(_react.Component)) || _class);
exports.default = (0, _reactStripeElements.injectStripe)(CheckoutForm);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckoutForm/CheckoutForm.js
// module id = 1733
// module chunks = 0